// Utils
import axiosInstance from "@/utils/axios-setup";

// React Libraries
import toast from "react-hot-toast";

export const createOrder = async (amount: number, currency: string) => {
    try {
      const response = await axiosInstance.post(`${process.env.NEXT_PUBLIC_EDGE_FUNCTION_BASE_URL}/create-order`, {
        amount , // Convert to cents
        currency,
      });
      return response.data.data.orderId; // Directly return the orderId from the response
    } catch (error) {
      toast.error(`Error creating order:, ${error}`);
      throw error;
    }
  };
  
  export const verifyPayment = async (paymentData: any) => {
    try {
      const response = await axiosInstance.post(`${process.env.NEXT_PUBLIC_EDGE_FUNCTION_BASE_URL}/verify-payment`, paymentData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      return response.data;
    } catch (error) {
      toast.error(`Error verifying payment:, ${error}`);
      throw error;
    }
  };


  export const getWalletBalance = async () => {
    try {
      const response = await axiosInstance.get(`${process.env.NEXT_PUBLIC_EDGE_FUNCTION_BASE_URL}/get-wallet-balance`, {
        headers: {
          Accept: 'application/json',
        },
      });
      return response.data.balance;
    } catch (error) {
      console.error(`Error fetching wallet balance:, ${error}`);
      throw new Error('Failed to fetch wallet balance');
    }
  };


  export const getWalletTransactions = async ({
    limit = 100,
    offset = 0,
    transaction_type,
    start_date,
    end_date
  }: any) => {
    try {
      const queryParams = new URLSearchParams({ 
        limit: limit.toString(), 
        offset: offset.toString() 
      });
  
      if (transaction_type) {
        queryParams.append('transaction_type', transaction_type);
      }
  
      // Convert dates to ISO format if they exist
      if (start_date) {
        // const formattedStartDate = new Date(start_date).toISOString();
        queryParams.append('start_date', start_date);
      }
  
      if (end_date) {
        // const formattedEndDate = new Date(end_date).toISOString();
        queryParams.append('end_date', end_date);
      }
  
      const response = await axiosInstance.get(`${process.env.NEXT_PUBLIC_EDGE_FUNCTION_BASE_URL}/get-wallet-transactions?${queryParams.toString()}`, {
        headers: { Accept: 'application/json' }
      });
  
      return response.data.transactions;
    } catch (error) {
      throw new Error('Failed to fetch wallet transactions');
    }
  };
  
  